import React, { useState } from "react";
import Grid from "@mui/material/Grid";
import { Collapse, IconButton, Box } from "@mui/material";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import FormGroup from "@mui/material/FormGroup";
import {TagCategory} from "../../gen/api";

type Props = {
  cluster: TagCategory
  children: React.ReactNode
}

/**
 * Renders a cluster of tags
 *
 * @param cluster
 * @param children
 * @constructor
 */
export default function Cluster({cluster, children}: Props) {
  const [isExpanded, setIsExpanded] = useState(false);
  return (
    <Grid item xs={12} sm={6} md={4} lg={3} xl={1.5}>
      <Box 
        sx={{ 
          display: 'flex', 
          alignItems: 'center', 
          cursor: 'pointer',
          '&:hover': { opacity: 0.8 }
        }}
        onClick={() => setIsExpanded(!isExpanded)}
      >
        <IconButton size="small">
          {isExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
        </IconButton>
        <p style={{ margin: 0, flexGrow: 1 }}>{cluster.name}</p>
      </Box>
      <Collapse in={isExpanded}>
        <FormGroup>
          {children}
        </FormGroup>
      </Collapse>
    </Grid>
  );
}